<template>
  <div>
    <b-modal
      id="edit-vaccintype-modal"
      ref="edit-vaccintype-modal"
      size="md"
      @hidden="cancel"
      :title="$t('modals.updateVaccintype.text')"
    >
      <!-- Name -->
      <div class="row">
        <div class="col-12 col-lg-12">
          <label for="name">{{$t("modals.name.text")}}</label>
          <b-form-input
            id="name"
            v-model="vaccintypeEdit.name"
            class="mb-1"
            :placeholder="$t('modals.name.text')"
            :state="err.name ? false : null"
          ></b-form-input>
          <b-form-invalid-feedback>
            {{ err.name }}
          </b-form-invalid-feedback>
        </div>
      </div>

      <template #modal-footer="{ ok, cancel }">
        <div class="row p-2">
          <div class="col-10 text-right p-1">
            <b-button variant="success" class="text-white" @click="edit(ok)">
              {{$t("buttons.update.text")}}
            </b-button>
          </div>
          <div class="col-2 text-center p-1">
            <b-button @click="cancel()"> {{$t("buttons.cancel.text")}} </b-button>
          </div>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
export default {
  props: ["vaccintype"],
  created() {},
  data() {
    return {
      vaccintypeEdit: {
        vaccintypeId: null,
        name: null,
      },
      err: {
        name: null,
      },
    };
  },
  watch: {
    vaccintype(newVal) {
      this.vaccintypeEdit = {
        vaccintypeId: newVal.id,
        name: newVal.name,
      };
    },
  },
  methods: {
    cancel() {
      this.clear();
    },
    clear() {
      /* this.vaccintypeEdit = {
        vaccintypeId: null,
        name: null,
      }; */
      this.err = {
        name: null,
      };
    },
    edit(ok) {
      if (!this.vaccintypeEdit.name) this.err.name = this.$t("msgError.obligField.text");
      else this.err.name = "";

      if (!this.err.name) {
        if (this.vaccintypeEdit.name != this.vaccintype.name) {
          ok();
          this.$emit("editVaccintype", this.vaccintypeEdit);
        } else {
          ok();
        }
      }
    },
  },
};
</script>